import React from 'react'
import CartPage from './CartPage'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Nav from '../Header/Nav'

const Cart = () => {
    return (
        <div>

            <Header />

            <Nav target="cart" />

            <CartPage />


            <Footer />


        </div>
    )
}

export default Cart